
import { useOutletContext } from "react-router-dom";
import { Trip } from "@/types/itinerary";
import { useItineraryTrip } from "@/hooks/useItineraryTrip";

// Component imports
import ItineraryView from "@/components/itinerary/ItineraryView";
import ErrorDisplay from "@/components/itinerary/ErrorDisplay";
import ItineraryLoading from "@/components/itinerary/ItineraryLoading";
import TripNotFound from "@/components/itinerary/TripNotFound";

interface TripContextType {
  trip: Trip;
  isAuthorized: boolean;
}

const Itinerary = () => {
  // Use context when available (from TripLayout)
  const context = useOutletContext<TripContextType | null>();
  
  // Custom hook for fetching trip data
  const { trip, isLoading, error } = useItineraryTrip(context?.trip || null);
  
  // Loading state for authentication
  if (isLoading && !trip) {
    return <ItineraryLoading />;
  }
  
  // Error state
  if (error) {
    return <ErrorDisplay message={error} />;
  }
  
  // Trip not found state
  if (!trip && !isLoading) {
    return <TripNotFound />;
  }
  
  // When inside trip layout, use context values
  if (context) {
    return (
      <ItineraryView 
        trip={trip} 
        isContextView={true}
        contextAuthorized={context.isAuthorized}
      />
    );
  }
  
  // Legacy view (when not in trip layout)
  return <ItineraryView trip={trip} />;
};

export default Itinerary;
